import Vue from 'vue'
import VueRouter from 'vue-router'



Vue.use(VueRouter)

export default new VueRouter({
  routes: [{
    path: '/xxcj',
    name: 'xxcj',
    children: [
      {
        path: 'list',
        name:'xxcj_list',
        component: () => import( /* webpackChunkName: "about" */ './views/xxcj/List.vue')
      }, {
        path: 'view/:id',
        name:'xxcj_view',
        component: () => import( /* webpackChunkName: "about" */ './views/xxcj/View.vue'),
        props: true
      }, {
        path: 'up/:id',
        name:'xxcj_up',
        component: () => import( /* webpackChunkName: "about" */ './views/xxcj/Up.vue'),
        props: true
      }, {
        path: 'miss/:id',
        name:'xxcj_miss',
        component: () => import( /* webpackChunkName: "about" */ './views/xxcj/Miss.vue'),
        props: true
      }, {
        path: 'upyj/:id',
        name:'xxcj_upyj',
        component: () => import( /* webpackChunkName: "about" */ './views/xxcj/UpYj.vue'),
        props: true
      }
    ],
    component: () => import( /* webpackChunkName: "about" */ './views/Xxcj.vue')
  },
  {
    path: '/xmgl',
    name: 'xmgl',
    children: [
      {
        path: 'dep',
        name: 'xmgl_dep',
        component: () => import( /* webpackChunkName: "about" */ './views/xmgl/Dep.vue')
      },
      {
        path: 'message',
        name: 'xmgl_message',
        component: () => import( /* webpackChunkName: "about" */ './views/xmgl/Message.vue')
      },
      {
        path: 'cjadd',
        name: 'xmgl_cjadd',
        component: () => import( /* webpackChunkName: "about" */ './views/components/CjEditSingle'),
        props: true
      },
      {
        path: 'cjedit',
        name: 'xmgl_cjedit',
        component: () => import( /* webpackChunkName: "about" */ './views/xmgl/CjEdit.vue')
      }, {
        path: 'cjeditsingle/:id',
        name: 'xmgl_cjeditsingle',
        component: () => import( /* webpackChunkName: "about" */ './views/components/CjEditSingle'),
        props: true
      },
      {
        path: 'cjcode',
        name: 'xmgl_cjcode',
        component: () => import( /* webpackChunkName: "about" */ './views/xmgl/CjCode.vue')
      },
      {
        path: 'cjinfo/:id',
        name: 'xmgl_cjinfo',
        component: () => import( /* webpackChunkName: "about" */ './views/xmgl/CjInfo.vue'),
        props: true
      },
      {
        path: 'yjinfo/:id',
        name: 'xmgl_yjinfo',
        component: () => import( /* webpackChunkName: "about" */ './views/xmgl/YjInfo.vue'),
        props: true
      },
      {
        path: 'fjinfo/:id',
        name: 'xmgl_fjinfo',
        component: () => import( /* webpackChunkName: "about" */ './views/xmgl/FjInfo.vue'),
        props: true
      },
      {
        path: 'fbinfo/:id',
        name: 'xmgl_fbinfo',
        component: () => import( /* webpackChunkName: "about" */ './views/xmgl/FbInfo.vue'),
        props: true
      },
    ],
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ './views/Xmgl.vue')
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ './views/Login.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    children: [
      {
        path: 'templateediter',
        name: 'admin_templateediter',
        component: () => import( /* webpackChunkName: "about" */ './views/admin/Templateediter.vue')
      },
      {
        path: 'accessediter',
        name: 'admin_accessediter',
        component: () => import( /* webpackChunkName: "about" */ './views/admin/Accessediter.vue')
      },
    ],
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ './views/Admin.vue')
  },
  {
    path: '/reset',
    name: 'reset',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ './views/Reset.vue')
  },
  {
    path: '/resetFirst',
    name: 'resetFirst',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ './views/ResetFirst.vue')
  },
  {
    path: '*', //其他页面，强制跳转到登录页面
    redirect: '/login'
  }
  ]
})